import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { availableLanguagesCodes } from './app/core/config';
import translationsEn from './assets/i18n/en.json';
import translationsPl from './assets/i18n/pl.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      pl: translationsPl,
      en: translationsEn,
    },
    ns: 'core',
    defaultNS: 'core',
    lng: availableLanguagesCodes[0],
    fallbackLng: availableLanguagesCodes[0],
    supportedLngs: availableLanguagesCodes,
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
